// const API = "https://bankingsoftwarebackend.onrender.com";
// export default API;

const API = "https://api.localnairainvest.com";
export default API;
